import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import { eventBus } from './eventBus'
import io from 'socket.io-client'
import axios from './axios.config.js'
import helpers from '../helpers.js';

import VueSweetalert2 from 'vue-sweetalert2'
import VueFileAgentNext from '@boindil/vue-file-agent-next'
import Notifications from '@kyvg/vue3-notification'

import 'bootstrap/scss/bootstrap.scss'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import './assets/css/global.css';
import 'sweetalert2/dist/sweetalert2.min.css'
import '@boindil/vue-file-agent-next/dist/vue-file-agent-next.css'
import 'bootstrap/dist/js/bootstrap.js'
import './registerServiceWorker'

const savedLang = localStorage.getItem('lang') || 'uk'
i18n.global.locale.value = savedLang
store.commit('lang/SET_LANGUAGE', savedLang)
helpers.setLang(store.state.lang.language);

const app = createApp(App)

app
  .use(i18n)
  .use(store)
  .use(router)
  .use(VueSweetalert2)
  .use(VueFileAgentNext)
  .use(Notifications)

// axios + token
app.config.globalProperties.$http = axios
const initialToken = localStorage.getItem('token')
app.config.globalProperties.$http.defaults.headers.common['Authorization'] = initialToken

let socket = null;

// WebSocket
function initializeSocket() {
  if (socket) {
    socket.disconnect();
  }

  socket = io('/', {
    auth: (callback) => {
      callback({
        token: localStorage.getItem('token')
      });
    }
  })

  // доступний для inject
  app.provide('$socket', socket)
  app.config.globalProperties.$socket = socket
}

initializeSocket()

eventBus.on('update-token', (newToken) => {
  app.config.globalProperties.$http.defaults.headers.common['Authorization'] = newToken
})

window.addEventListener('storage', (event) => {
  if (event.key === 'lang') {
    const newLang = event.newValue || 'uk'
    i18n.global.locale.value = newLang
    store.commit('lang/SET_LANGUAGE', newLang)
  }
})

app.use(VuePlyr)

app.mount('#app')